module.exports = __webpack_public_path__ + "static/media/placeholder.6f1849bd.png";